import { createSlice } from '@reduxjs/toolkit';

let initialState = {
  workCd: '', // 작업코드
  stopWorking: 0, // 0: 작업중, 1: 작업중지, 2: 작업재개
  workStopCd: '', // 작업중지코드
  workStopAlarm: '', // 작업 중지 승인 메뉴 뱃지: '요청' = 승인요청
};

const WorkingCheckSlice = createSlice({
  name: 'WorkingCheck',
  initialState,
  reducers: {
    setWorkCd(state, action) {
      state.workCd = action.payload;
    },
    setStopWorking(state, action) {
      state.stopWorking = action.payload;
    },
    setWorkStopCd(state, action) {
      state.workStopCd = action.payload;
    },
    clearWorkEnd(state) {
      state.workCd = '';
    },
    clearWorkStop(state) {
      state.stopWorking = 0;
      state.workStopCd = '';
    },
    setWorkStopAlarm(state, action) {
      state.workStopAlarm = action.payload ?? '';
    },
  },
});

export const WorkingCheckActions = WorkingCheckSlice.actions;
export default WorkingCheckSlice.reducer;
